import { get } from 'lodash-es'

import CONSTANTS from './constants'
import API_CONSTANTS from '@/js/helper/api-constants.js'
import GETTER_TYPES from './getter-types'

export const getGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.MESSAGES]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES.dataKey,
        API_CONSTANTS.RELATIONSHIPS,
        API_CONSTANTS.MESSAGE.MESSAGE,
        API_CONSTANTS.DATA,
      ],
      [],
    ),
  [GETTER_TYPES.STATUS_MESSAGES]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_STATUS.dataKey,
        API_CONSTANTS.RELATIONSHIPS,
        API_CONSTANTS.MESSAGE.MESSAGE,
        API_CONSTANTS.DATA,
      ],
      [],
    ),
  [GETTER_TYPES.TOTAL]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_STATUS.dataKey,
        API_CONSTANTS.META.TYPE,
        API_CONSTANTS.MESSAGE.TOTAL,
      ],
      0,
    ),
  [GETTER_TYPES.READ_TOTAL]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_STATUS.dataKey,
      API_CONSTANTS.META.TYPE,
      API_CONSTANTS.MESSAGE.READ,
    ]),
  [GETTER_TYPES.UNREAD_TOTAL]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_STATUS.dataKey,
      API_CONSTANTS.META.TYPE,
      API_CONSTANTS.MESSAGE.UNREAD,
    ]),
  [GETTER_TYPES.MESSAGES_DETAIL]: state =>
    get(state, [MUTATION_TYPES.MESSAGES_DETAIL.dataKey, API_CONSTANTS.ATTRIBUTES], {}),
  [GETTER_TYPES.MESSAGE_TYPE]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.TYPE,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_BODY]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.BODY,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_ARTICLES]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.ARTICLES,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_DATE]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.DATE,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_FROM_EMAIL]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.FROM_EMAIL,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_FROM_NAME]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.FROM_NAME,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_TITLE]: state =>
    get(
      state,
      [
        MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
        API_CONSTANTS.ATTRIBUTES,
        API_CONSTANTS.MESSAGE.TITLE,
      ],
      '',
    ),
  [GETTER_TYPES.MESSAGE_READ]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.READ,
    ]),
  [GETTER_TYPES.MESSAGE_ARCHIVED]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.ARCHIVED,
    ]),
  [GETTER_TYPES.MESSAGE_PRIORITY]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.PRIORITY,
    ]),
  [GETTER_TYPES.MESSAGE_UID]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.UID,
    ]),
  [GETTER_TYPES.MESSAGE_TICKET_ID]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.TICKET_ID,
    ]),
  [GETTER_TYPES.MESSAGE_STATUS]: state =>
    get(state, [
      MUTATION_TYPES.MESSAGES_DETAIL.dataKey,
      API_CONSTANTS.ATTRIBUTES,
      API_CONSTANTS.MESSAGE.TICKET_STATUS,
    ]),
  [GETTER_TYPES.MESSAGE_PREVIEW_DATA]: state => get(state, CONSTANTS.MESSAGE_PREVIEW_DATA),
})
